import Menu from 'semantic-ui-react/dist/commonjs/collections/Menu'
export default Menu
